(function () {
  'use strict'

  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Controllers').controller('NpsSurveyController', NpsSurveyController)

  NpsSurveyController.$inject = ['$rootScope', 'NotificationService', 'NpsSurveyService']

  function NpsSurveyController ($rootScope, NotificationService, NpsSurveyService) {
    var vmNpsSurveyCtrl = this
    vmNpsSurveyCtrl.gradeRange = ''

    construct()
    function construct () {
      getGradeRange()
    }

    function getGradeRange () {
      NpsSurveyService
        .all()
        .$promise
        .then(function (data) {
          console.log(data)
          vmNpsSurveyCtrl.gradeRange = data.gradeRange
        })
        .catch(function (data) {
          NotificationService.errorHandler(null, 'Erro ao buscar os dados.')
        })
    }

    vmNpsSurveyCtrl.updateGradeRange = function () {
      NpsSurveyService
        .update({ gradeRange: vmNpsSurveyCtrl.gradeRange })
        .$promise
        .then(function () {
          NotificationService.successHandler(null, 'Range atualizado com sucesso!')
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao atualizar os dados.')
        })
    }
  }

// eslint-disable-next-line semi
})();
